import { render, staticRenderFns } from "./IM_4_1.vue?vue&type=template&id=d49cc490&scoped=true&"
import script from "./IM_4_1.vue?vue&type=script&lang=js&"
export * from "./IM_4_1.vue?vue&type=script&lang=js&"
import style0 from "./IM_4_1.vue?vue&type=style&index=0&id=d49cc490&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49cc490",
  null
  
)

export default component.exports